import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Banner = styled.div`
  display: flex;
  align-items: center;
  gap: var(--default-padding-small);
  box-sizing: border-box;
  width: 100%;
  max-width: 818px;
  min-height: 115px;
  padding: var(--default-padding) var(--big-padding);
  border-radius: var(--semi-medium-border-radius);
  background: linear-gradient(
      var(--green-opacity-lighter),
      var(--green-opacity-lighter)
    ),
    var(--white-main);
  border: 1px solid var(--phishing-border);
`;

const Stat = styled.span`
  flex-shrink: 0;
  font-size: var(--stat-font-size);
  font-weight: 700;
  line-height: 1.4;
  color: var(--phishing-stat);
`;

const Description = styled.p`
  margin: 0;
  font-size: var(--medium-font-size);
  font-weight: 400;
  line-height: var(--default-line-height);
  color: var(--green-chart-dark);

  strong {
    font-weight: 600;
  }
`;

type ProofPointBannerProps = {
  stat?: string;
  description?: string;
  className?: string;
};

export const ProofPointBanner: React.FC<ProofPointBannerProps> = ({
  stat,
  description,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <Banner className={className}>
      <Stat>{stat ?? t('phishing.intro.proof.stat')}</Stat>
      <Description
        dangerouslySetInnerHTML={{
          __html: description ?? t('phishing.intro.proof.description'),
        }}
      />
    </Banner>
  );
};
